export default {
  "Footer.CompanyAddress1": "11/1 ซอย ประชาราษฎร์ 14",
  "Footer.CompanyAddress2": "ต.ตลาดขวัญ อ.เมืองนนทบุรี",
  "Footer.CompanyAddress3": "จ.นนทบุรี 11000",
  "Footer.Title": "(ที่อยู่ในการออกเอกสาร)",
  "Footer.MailAddress1":
    "ตึกซีดับเบิ้ลยู ทาวเวอร์(ไซเบอร์ เวิลด์) ตึก A ชั้น 31",
  "Footer.MailAddress2": "90 ถนนรัชดาภิเษก เขตห้วยขวาง",
  "Footer.MailAddress3": "กรุงเทพฯ 10310",
  "BOOK.NOW": "ขอใบเสนอราคา",
  "Footer.ContactUs": "ติดต่อ Vecabo",
  "Footer.News": "ติดตามข่าวสาร",
  "Footer.Why": "ทำไมต้อง Vecabo",
  FullCompanyName: "VECABO CO.,LTD.",
  HISOBUS: "Vecabo",
  Search: "ค้นหา",
  HowToPay: "วิธีการจ่ายเงิน",
  HowToBooking: "วิธีการจอง",
  PENDING: "รอดำเนินการ",
  PAY: "จ่ายเงินเรียบร้อย",
  CANCEL: "ยกเลิกการเดินทาง",
  CANCEL_MODAL: "ยกเลิก",
  ONTRIP: "กำลังเดินทาง",
  DONE: "จบการเดินทาง",
  Baht: "บาท",
  Back: "ย้อนกลับ",
  Total: "ทั้งหมด",
  READMORE: "เพื่มเติม",
  Quotation: "การออกใบเสนอราคา",
  Add: "เพิ่ม",
  Pay: "จ่ายเงิน",
  Insurer_Nanme: "รายชื่อผู้รับประกัน",
  PAID: "จ่ายเงินเรียบร้อย",
  Detail: "รายละเอียด",
  Company: "บริษัท",
  Home: "หน้าแรก",
  Name: "ชื่อ-นามสกุล",
  Signin: "เข้าสู่ระบบ",
  Register: "สมัครสมาชิก",
  Signout: "ออกจากระบบ",
  Blog: "บทความ",
  AbousUs: "เกี่ยวกับเรา",
  BlogDetail: "รายละเอียดบทความ",
  AboutUs: "เกี่ยวกับเรา",
  Booking: "จองรถ",
  Booking2: "จองเลย",
  PriceStart: "ราคาเริ่มต้น",
  ContactUs: "ติดต่อเรา",
  Service: "บริการ",
  Gallery: "อัลบั้ม",
  HowTo: "วิธีการจอง/จ่ายเงิน",
  Email: "อีเมล์",
  TripObjective: "จุดประสงค์การเดินทาง",
  Password: "รหัสผ่าน",
  ConfirmPassword: "ยืนยันรหัสผ่าน",
  ForgotPassword: "ลืมรหัสผ่าน",
  Submit: "ตกลง",
  Or: "หรือ",
  SigninWithFacebook: "เข้าสู่ระบบด้วย Facebook",
  SigninWithGoogle: "เข้าสู่ระบบด้วย Google",
  FirstName: "ชื่อ",
  LastName: "นามสกุล",
  PhoneNumber: "เบอร์โทรศัพท์",
  LineId: "ไลน์ไอดี",
  Facebook: "Facebook",
  Address: "ที่อยู่",
  notFoundData: "ไม่พบข้อมูล",
  ViewMore: "ดูเพิ่มเติม",
  OtherBlog: "บทความอื่นๆ",
  MyBooking: "รายการจอง",
  MyBookingDetail: "รายละเอียดการจอง",
  MyBus: "รถของเรา",
  Next: "ถัดไป",
  Close: "ปิด",
  Quantity: "จำนวน",
  Remove: "ลบ",
  PleaseSignin: "โปรดเข้าสู่ระบบก่อน",
  Faq: "คำถามที่พบบ่อย",
  Follow: "ติดตามข่าวสาร",
  Summary: "สุทธิ",
  Message: "ข้อความ",
  Send: "ส่งข้อความ",
  EmailConfirm: "สมัครสมาชิกสำเร็จ",
  EmailConfirmContent: "คุณสามารถเข้าสู่ระบบได้ในขณะนี้",
  EmailConfirmInvalid: "สมัครสมาชิกไม่สำเร็จ",
  Save: "บันทึกข้อมูล",
  Reset: "รีเซ็ต",
  UpdateUserProfileSuccessful: "แก้ไขข้อมูลส่วนตัวสำเร็จ",
  Thankyou: "ขอบคุณ",
  ThankyouSec: "ที่เลือกใช้บริการจากทาง Vecabo",
  UserInfo: "โปรไฟล์ของฉัน",
  EditProfile: "แก้ไขข้อมูลส่วนตัว",
  MyVehicles: "รถของฉัน",
  seeYourTrip:
    "ทางเราได้ทำการส่งใบเสนอราคาผ่านทางอีเมล์ให้คุณเรียบร้อยแล้วหลังจากที่คุณทำการจองอย่างเสร็จสมบูรณ์",
  seeYourTripSec:
    "Vecabo มั่นใจว่าลูกค้าทุกท่านจะได้การบริการยอดเยี่ยมพร้อมความประทับใจจากทางเราเป็นอย่างดี",

  // signin-validation
  "Signin.Validation.Email.Required": "โปรดกรอกอีเมล์",
  "Signin.Validation.Email.Invalid": "อีเมล์ไม่ถูกต้อง",
  "Signin.Validation.Password.Required": "โปรดกรอกรหัสผ่าน",
  // register-validation
  "register.Validation.ConfirmPassword.Required": "โปรดยืนยันรหัสผ่าน",
  "register.Validation.ConfirmPassword.Validator": "รหัสผ่านต้องเหมือนกัน",
  "register.Validation.FirstName.Required": "โปรดกรอกชื่อ",
  "register.Validation.LastName.Required": "โปรดกรอกนามสกุล",
  "register.Validation.PhoneNumber.Required": "โปรดกรอกเบอร์โทรศัพท์",
  "register.Validation.CompanyName.Required": "โปรดกรอกชื่อบริษัท",
  "register.Validation.TaxId.Required": "โปรดกรอกเลขประจำตัวผู้เสียภาษีอากร",
  "register.Validation.CompanyAddress.Required": "โปรดกรอกที่อยู่บริษัท",
  "register.Validation.Branch.Required": "โปรดระบุสาขา",
  "register.Validation.Country.Required": "โปรดเลือกประเทศ",
  "register.Validation.Province.Required": "โปรดเลือกจังหวัด",
  "register.Validation.District.Required": "โปรดเลือกเขต/อำเภอ",
  "register.Validation.SubDistrict.Required": "โปรดเลือกแขวง/ตำบล",
  "register.Validation.ZipCode.Required": "โปรดกรอกรหัสไปรษณีย์",
  "register.Validation.BusinessType.Required": "โปรดเลือกประเภทธุรกิจ",
  "BusinessRegister.Success.Title": "การลงทะเบียนสำเร็จ",
  "BusinessRegister.Success.Content": "กรุณารอการติดต่อกลับจากเจ้าหน้าที่",
  "PartnerRequest.Success.Title": "การลงทะเบียนสำเร็จ",
  "PartnerRequest.Success.Content": "กรุณารอการติดต่อกลับจากเจ้าหน้าที่",
  "register.Success.ConfirmEmail":
    "ลงทะเบียนเรียบร้อย, โปรดยืนยันการลงทะเบียนผ่านทางอีเมล์",
  // payment-validation
  "payment.Validation.HolderName.Required": "โปรดกรอกชื่อผู้ถือบัตร",
  "payment.Validation.CardNumber.Required": "โปรดกรอกหมายเลขบัตรเครดิต/เดบิต",
  "payment.Validation.securityCode.Required":
    "โปรดกรอกรหัสความปลอดภัยของบัตร (CVV)",
  "payment.Validation.Month.Required": "โปรดกรอกเดือนที่บัตรหมดอายุ",
  "payment.Validation.Year.Required": "โปรดกรอกปีที่บัตรหมดอายุ",
  // reset-password
  "resetpassword.header.second":
    "โปรดกรอกอีเมล์และตรวจสอบการเปลี่ยนแปลงรหัสผ่านได้ที่อีเมล์ของท่าน",
  "resetpassword.button.send": "ยืนยันการเปลี่ยนรหัสผ่าน",
  "resetpassword.Success": "กรุณาตรวจสอบการเปลี่ยนรหัสผ่านที่อีเมล์ของท่าน",
  "resetpassword.confirm.Success":
    "เปลี่ยนรหัสผ่านสำเร็จ กรุณาเข้าสู่ระบบอีกครั้ง",
  "resetpassword.confirm.header": "ยืนยันการเปลี่ยนรหัสผ่าน",
  // Language-Switcher
  "langSwitcher.ChangeLanguage": "เปลี่ยนภาษา",
  "langSwitcher.th": "ภาษาไทย",
  "langSwitcher.en": "ภาษาอังกฤษ",

  // About Us
  "aboutUs.second.title":
    "Vecabo บริการเช่ารถบัสและรถตู้ที่เติมเต็มทุกการเดินทาง",
  OurTeam: "ทีมของเรา",
  "ourteam.profile1.name": "ศุภกร เกียรติแสงทอง",
  "ourtem.profile1.position": "Founder & CEO",
  "ourteam.profile2.name": "จีรยุทร สุดเจริญ",
  "ourtem.profile2.position": "Chief Executive Officer (CEO)",
  "ourteam.profile3.name": "จักพันธ์ เพชรแอน",
  "ourtem.profile3.position": "Co-Founder & CTO",
  "ourteam.profile4.name": "กิตติ พรศิวะกิจ",
  "ourtem.profile4.position": "Co-Founder & CXO",
  "ourteam.profile5.name": "BANGKOK VENTURES",
  "ourtem.profile5.position": "Co-Founder & Advisor",
  "ourteam.profile6.name": "วริทร์ธร วิริยะมนตรี",
  "ourtem.profile6.position": "Chief Technology Officer (CTO)",
  "ourteam.profile7.name": "ภาวุธ พงษ์วิทยภานุ.",
  "ourtem.profile7.position": "Chief Strategy Officer (CSO)",
  // Booking
  "bookingDetail.Destination": "เลือกจุดหมาย",
  "bookingDetail.Payment": "รายละเอียดราคา",
  "bookingDetail.EditSearch": "แก้ไขรายละเอียด",
  "bookingDetail.AddBus": "เพิ่มรถ",
  "bookingDetail.AddRoute": "เพิ่มจุดแวะเที่ยว",
  "bookingDetail.MapRoute": "จุดแวะเที่ยวของคุณ",
  "bookingPayment.From": "จาก",
  "bookingPayment.To": "ไปยัง",
  "bookingPayment.No": "ลำดับ",
  "bookingPayment.Date": "วันที่",
  "bookingPayment.DateTotal": "จำนวนวันรวม",
  "bookingPayment.Days": "วัน",
  "bookingPayment.Passenger": "ผู้โดยสาร",
  "bookingPayment.People": "คน",
  "bookingPayment.Description": "รายละเอียด",
  "bookingPayment.Units": "จำนวน",
  "bookingPayment.Unit": "จำนวนละ",
  "bookingPayment.Price": "ราคา",
  "bookingPayment.Total": "รวม",
  "bookingPayment.Quotation": "ต้องการใบเสนอราคา",
  "bookingPayment.Pay": "จ่ายเงิน",
  // HomePage
  "homgPage.Title":
    "เช่ารถบัส และ รถตู้ จองง่าย บริการดี มีรถมากที่สุดในประเทศไทย",
  "homePage.Reviews": "รีวิวลูกค้า",
  "homePage.OurClients": "ลูกค้าของเรา",
  "homePage.Transmitters": "ผู้สนับสนุน",
  "homePage.Media": "สื่อที่พูดถึงเรา",
  "homePage.PopularDestination": "ที่ท่องเที่ยวที่มีชื่อเสียง",
  "homePage.HowtoService": "Vecabo ใช้บริการยังไง",
  "homePage.Step1": "ขั้นตอนที่ 1",
  "homePage.Step2": "ขั้นตอนที่ 2",
  "homePage.Step3": "ขั้นตอนที่ 3",
  "homePage.Step4": "ขั้นตอนที่ 4",
  "homePage.Step1.desc": "เลือกประเภทรถ",
  "homePage.Step2.desc": "เลือกจุดหมายปลายทาง",
  "homePage.Step3.desc": "ยืนยันการจอง",
  "homePage.Step4.desc": "ชำระเงิน",
  // MyBooking
  "myBooking.header.myProfile": "โปรไฟล์",
  "myBooking.header.currentMyBooking": "รายการปัจจุบัน",
  "myBooking.header.historyMyBooking": "รายการย้อนหลัง",
  // BookingFrom
  "bookingfrom.bus": "รถบัส",
  "bookingfrom.van": "รถตู้",
  "bookingfrom.roundTrip": "ไป - กลับ",
  "bookingfrom.oneWayTrip": "เที่ยวเดียว",
  "bookingfrom.from": "จุดเริ่มต้น",
  "bookingfrom.departureDate": "วันที่ออกเดินทาง",
  "bookingfrom.destination": "ปลายทาง",
  "bookingfrom.returnDate": "วันที่เดินทางกลับ",
  "bookingfrom.departureTime": "เวลาออกเดินทาง",
  "bookingfrom.returnTime": "เวลาเดินทางกลับ",
  "bookingfrom.busType": "ประเภทรถ",
  "bookingfrom.quantity": "จำนวน (คัน)",
  "bookingfrom.passengers": "ผู้โดยสาร (คน)",
  "bookingfrom.plaseSelectfrom": "กรุณาเลือกจุดเริ่มต้นของการเดินทาง",
  "bookingfrom.plaseSelectDepartureDate": "กรุณาเลือกวันที่ออกเดินทาง",
  "bookingfrom.plaseSelectDestination": "กรุณาเลือกปลายทางของการเดินทาง",
  "bookingfrom.plaseSelectReturnDate": "กรุณาเลือกวันที่เดินทางกลับ",
  "booking.payment.summaryOrder": "รายการจองรถทั้งหมด",
  "booking.payment.summaryRouteOrder": "รายการท่องเที่ยวทั้งหมด",
  "book.title":
    "เช่ารถบัสและรถตู้ ผ่าน Vecabo สะดวก รวดเร็ว และตอบทุกความต้องการของคุณ",
  "book.checking.price": "เช็คราคาฟรี",
  Pleasewait: "โปรดรอสักครู่",
  // Popular Destination
  kanchanaburi: "กาญจนบุรี",
  suanPhueng: "สวนผึ้ง",
  khaoyai: "เขาใหญ่",
  huahin: "หัวหิน",
  pattaya: "พัทยา",
  NickName: "ชื่อเล่น",
  PartnerWithUs: "ร่วมงานกับเรา",
  Pricing: "อัตราค่าบริการ",
  BusPrice1: "รถบัสปรับอากาศ",
  BusPrice2: "รถตู้ปรับอากาศ",
  BusPriceSeat1: "18, 20, 25, 30 ที่นั่ง",
  BusPriceSeat2: "35 - 45 ที่นั่ง",
  BusPriceSeat3: "50 ที่นั่ง",
  BusPriceSeat4: "10 - 13 ที่นั่ง",
  VanPriceSeat1: "11 ที่นั่ง",
  VanPriceSeat2: "6 - 10 ที่นั่ง",
  VanPriceSeat3: "6 - 9 ที่นั่ง",
  VanPrice: "2,200 บาท",
  VanPrice2: "2,800 - 11,000 บาท",
  VanPrice3: "15,500 บาท",
  ServiceGasToil: "***ไม่รวมค่าน้ำมัน, ค่าที่จอดรถ และค่าทางด่วน",
  ServiceGasToil2: "***รวมค่าน้ำมัน, ค่าที่จอดรถ และค่าทางด่วน",
  ServiceHours: "ชั่วโมงบริการ",
  TenHours: "10 ชั่วโมง",
  TwelveHours: "12 ชั่วโมง",
  price: "ราคา",
  distance: "ระยะทาง",
  abbkm: "ก.ม.",
  km: "กิโลเมตร",
  above: "มากกว่า",
  OTperHour: "OT ชั่วโมงละ",
  OTPrice1: "200 บาท",
  OTPrice2: "300 - 1,000 บาท",
  OTPrice3: "2,000 บาท",
  companyname: "ชื่อบริษัท",
  pricepolicy1: "ราคาดังกล่าวคือราคาต่อวัน",
  pricepolicy2: "ไม่รวมค่าทางด่วน",
  pricepolicy3: "ราคาดังกล่าวไม่รวมค่าจอดรถ",
  pricepolicy: "เงื่อนไขราคา การใช้บริการรถบัส",
  ftlheader: "อัตราค่าบริการเช่ารถบัส",
  nodata: "-",
  ftl:
    "ค่าบริการเช่ารถบัสเหมาคัน (FTL) ภายในประเทศใช้วิธีคิดตามระยะทาง คุณสามารถดูอัตราค่าบริการได้ตามประเภทรถที่ต้องการใช้บริการของรถบัส",
  "hisobus-sp-spacial-services": "บริการพิเศษจาก Vecabo",
  whyhisobus: "ทำไมต้อง Vecabo",
  suggestion: "ข้อความแสดงความคิดเห็น",
  ContactNumber: "02-0803972",
  taxId: "เลขประจำตัวผู้เสียภาษีอากร",
  CompanyAddress: "ที่อยู่บริษัท",
  CompanyAddress2: "ที่อยู่บริษัท 2",
  branch: "สาขา",
  country: "ประเทศ",
  province: "จังหวัด",
  district: "เขต/อำเภอ",
  subdistrict: "แขวง/ตำบล",
  selectplaceholder: "--- เลือก ---",
  zipcode: "รหัสไปรษณีย์",
  businesstype: "ประเภทธุรกิจ",
  contactNumber: "เบอร์ติดต่อ",
  inviteCode: "รหัสคำเชิญ",
  businessRegister: "ลงทะเบียนสำหรับธุรกิจ",
  InputBusiness: "ระบุข้อมูลบริษัท",
  bookingStep0: "ค้นหารถ",
  bookingStep1: "เลือกรถ",
  bookingStep2: "ตรวจสอบข้อมูล",
  bookingStep3: "ชำระเงิน",
  scb: "บมจ.ไทยพาณิชย์",
  accountNumber: "เลขบัญชี",
  Services: "บริการลูกค้า",
  InfoMation: "ข้อมูลข่าวสาร",
  Tel: "โทร",
  why1: "ปลอดภัย",
  why2: "ราคามาตรฐาน",
  why3: "รถบัสหลายประเภท",
  why4: "ผู้โดยสาร",
  why4_2:
    "มีผู้โดยสารมากกว่า 1 ล้าน 5 แสนคน ที่ร่วมเป็นส่วนหนึ่งในเดินทางด้วยรถบัสและรถตู้กับ Vecabo และผู้โดยสารมากกว่า 98 % มั่นใจที่จะเลือกใช้บริการของ Vecabo",
  why5: "ทริปการเดินทาง",
  why5_2:
    "Vecabo มีส่วนร่วมกับผู้คนและการเดินทางด้วยบริการเช่ารถบัสที่แสนพิเศษมามากกว่า 30,000 +ทริปการเดินทาง",
  why6: "ประสบการณ์ที่ผ่านมา",
  why6_2:
    "ประสบการณ์ที่ผ่านมา Vecabo มีผู้ประกอบการที่ให้บริการเช่ารถบัสที่มีประการณ์ในการทำธุรกิจให้เช่ารถบัสมามากกว่า 30ปี",
  why7: "การเดินทางบนท้องถนน",
  why7_2:
    "การเดินทางบนท้องถนน Vecabo ร่วมการเดินทางบนท้องถนนกับผู้คนมากกว่าสิบล้านกิโลเมตรเราจึงมีประสบการณ์ ชำนานเส้นทาง ที่ไหนมีถนนรถบัสของเราไปได้ทุกที่",
  whydetail1:
    "Vecabo ให้ความสำคัญด้านความปลอดภัยในการเดินทาง เรามีเทคโนโลยีที่สามารถควบคุมความเร็วที่มีประสิทธิภาพรวมถึงพนักงานขับรถของเราได้รับการอบรมมาเป็นอย่างดี",
  whydetail2:
    "ค่าบริการเช่ารถบัสจะถูกคิดตามระยะทางจริง ไม่มีราคาแอบแฝง หากผู้โดยสารมีงบจำกัดก็สามารถเดินทางด้วยรถบัสได้",
  whydetail3:
    "Vecabo มีรถหลากหลายประเภทกว่า 2000 คัน พร้อมที่จะให้บริการให้เหมาะสมกับการเดินทางที่แสนพิเศษของคุณ",
  whydetail4:
    "บริการเช่ารถบัส 24 ชั่วโมง ง่ายๆไม่ถึง 5 นาที แค่เลือกเช่ารถบัสที่ต้องการใช้บริการและได้รถชัวร์ 100 %",
  service1: "ทริปสำหรับนักศึกษา",
  service2: "ท่องเที่ยวกับบริษัท",
  service3: "ทัศนศึกษา",
  service4: "ทริปสุดพิเศษสำหรับคู่รัก และ ครอบครัว",
  service5: "ทริปสายบุญ",
  service6: "ทริปสำหรับนักเรียน",
  service7: "1 วันก็เที่ยวได้",
  service8: "สัมมนาบริษัท",
  service9: "กีฬา",
  transmitter:
    "และมีองค์กรบริษัทอีกมากมายที่กำลังพูดถึงเราในตอนนี้อาทิเช่น GSB สุดยอดสตารท์อัพ, Panus Thailand, ไทยรัฐทีวี, หนังสือพิมพ์ฐาน เศรษฐกิจ กระทรวงอุตสาหกรรมกรมส่งเสริมอุตสสาหากรรม, สภาอุตสาหกรรมการท่องเที่ยวแห่งประเทศไทย, BusinessLinX GlobalLinker และ สมาคมการตลาดท่องเที่ยวไทย",
  media: "เครื่องส่งสัญญาณสื่อของเรา",
  remarksPetrol: "ราคานี้รวมน้ำมัน",
  remarksExpressWay: "ราคานี้ไม่รวมค่าทางด่วนและค่าที่จอดรถ",
  remarksDriver: "ราคานี้รวมค่าพนักงานขับรถและผู้ช่วยพนักงานขับรถแล้ว",
  air: "เครื่องปรับอากาศ",
  busDriver: "คนขับรถ",
  toilet: "ห้องน้ำ",
  usb: "usb",
  facilities: "สิ่งอำนวยความสะดวก",
  remarks: "หมายเหตุ",
  includesVat: "ราคารวมภาษีมูลค่าเพิ่ม",
  excludesVat: "ราคายังไม่รวมภาษีมูลค่าเพิ่ม",
  addToWishlist: "เพิ่มในรายการ",
  bestDeals: "ดีที่สุด",
  cheapest: "ถูกที่สุด",
  recommendForYou: "แนะนำ",
  vehicles: "รถที่คุณเลือกใช้",
  defaultBusType: "เลือกรถ",
  seat: "ที่นั่ง",
  safetyBelt: "เข็มขัดนิรภัย",
  electricMassageSeat: "เบาะนวดไฟฟ้า",
  lcdTV: "LCD TV",
  specialService: "บริการพิเศษอื่นๆ",
  electroacoustics: "เครื่องเสียง",
  gpsTracking: "GPS Tracking",
  bus: "คัน",
  people: "คน",
  limitedSpace: "จำกัดพื้นที่บริการ",
  bangkok: "กทม.",
  yourBuses: "รถที่คุณเลือก",
  yourVans: "บริการให้เช่ารถตู้พร้อมคนขับรถ",
  vanDriver: "คนขับรถ",
  yourRecommendBuses: "รถที่แนะนำสำหรับคุณ",
  busSelected: "คุณเลือกรถประเภทนี้เรียบร้อยแล้ว",
  loading: "กรุณารอสักครู่...",
  tripchecking: "ตรวจสอบข้อมูลการเดินทาง",
  loginrequired: "กรุณาสมัครสมาชิกหรือเข้าสู่ระบบเพือทำรายการต่อไป",
  confirmbooking: "ยืนยันข้อมูล หรือรับใบเสนอราคา",
  yourbusdetail: "รายละเอียดรถที่คุณเลือก",
  bookerdetail: "กรอกรายละเอียดผู้จองรถ",
  paymentoption: "ช่องทางชำระเงิน",
  onlinebanking: "ธนาคารออนไลน์",
  totalprice: "จำนวนเงินรวม",
  vat: "ภาษีมูลค่าเพิ่ม",
  netprice: "จำนวนเงินรวมสุทธิ",
  deposit: "ยอดเงินมัดจำ",
  withat: "มี @ ด้วย",
  sendinvoice:
    "หลังจากโอนเสร็จแล้วให้คุณลูกค้าโทรแจ้งยืนยันการชำระเงิน ถ่ายสลิปการโอนเงิน แล้วส่งเข้ามาที่",
  informinvoice: "แจ้งยืนยันการชำระเงิน",
  copyright: "สงวนลิขสิทธิ์",
  partnertitle: "โอกาสสร้างรายได้ใหม่สำหรับผู้ประกอบการรถบัสและรถตู้ สมัครเลย!",
  bookingbackalert: "การจองรถสำเร็จแล้ว! ขอบคุณที่ใช้บริการ Vecabo",
  bookingbackalert2:
    "คุณสามารถตรวจสอบสถานะการจองได้ที่ 'รายการจอง' หรือ จองรถอีกครั้งที่ 'จองรถ'",
  creditcard: "บัตรเครดิต/เดบิต",
  cardnumber: "หมายเลขบัตร",
  expirydate: "วันหมดอายุ",
  expirydate2: "เดือน / ปี",
  confirmpayment: "ยืนยันการชำระเงิน",
  fullPayment: "ขอสงวนสิทธิ์ในการชำระเป็นจำนวนเงินเต็ม เมื่อชำระผ่านบัตรเครดิต",
  tooltipStop: "คุณสามารถสร้างโปรแกรมการเดินทางได้ที่นี",
  customerservice: "ติดต่อฝ่ายลูกค้าสัมพันธ์",
  complain: "การแก้ปัญหาข้อร้องเรียน",
  busstandard: "มาตรฐานการให้บริการ",
  workinghour: "จันทร์ - ศุกร์ 09.00 - 18.00",
  complainpolicy: "นโยบายการแก้ปัญหาข้อร้องเรียน",
  busstandardscreen: "มาตรฐานการคัดกรองผู้ให้บริการรถบัส",
  aboutUs: "เกี่ยวกับเรา",
  promocode: "โค้ดส่วนลด",
  apply: "ใช้โค้ด",
  discount: "ส่วนลด",
  "Staycation Time": "ได้เวลาเที่ยวแล้ว",
  "Feel Fun! One Day Trip Time": "ฟิน ฟิน แบบ วัน เดย์ ทริป",
  "Feel Fun! Friend Group Time": "เที่ยวฟิน ฟิน กับเพื่อนรัก",
  "Feel Fun! Outing Time": "เที่ยวฟิน ฟิน กับเพื่อนร่วมงาน",
  "Feel Fun! Merit Time": "เที่ยวกัน เพราะสายบุญ",
  "Feel Fun! School Trip Time": "เที่ยวแบบนี้ เด็กๆชอบ",
  booking_period: "ระยะเวลาการจอง",
  today: "วันนี้",
  travel_time: "ระยะเวลาเดินทาง",
  travel_code: "รหัสส่วนลดของคุณ",
  apply_to: "กรอกรหัสส่วนลดนี้ที่หน้าชำระเงิน",
  how_to_get: "วิธีการใช้รหัสส่วนลดเช่ารถบัส",
  condtion_term: "ข้อกำหนดและเงื่อนไข",
  coupon_term: "ข้อกำหนดและเงื่อนไขของรหัสส่วนลด",
  "homePage.promotion": "โปรโมชั่น",
  "blog.blog3.title": "ขับรถเที่ยวใกล้กรุงเทพฯ 7 ทริป ชิลๆ ไปเช้ากลับเย็น",
  Customer: "ลูกค้าของเรา",
  Tool: "เครื่องมือ",
  VehicleManagement: "ระบบบริหารจัดการรถ",
  ShouldInputYouPhonenumber: "กรุณากรอกหมายเลขโทรศัพท์ของคุณ",
  personal: "ส่วนบุคคล",
  corporation: "บริษัท",
  insurance: "ประกันภัย",
  assurer: "ผู้รับประกันภัย",
  Add_Assurer: "เพิ่มผู้ประกันตน",
  insurance_company: "บริษัทประกันภัย",
  datesday: "โปรดระบุวันเกิดของคุณ",
  datesmonth: "โปรดระบุเดือนเกิดของคุณ",
  datesyear: "โปรดระบุปีเกิดของคุณ",
  date: "วัน/เดือน/ปี",
  dateday: "วันเกิด",
  datemonth: "เดือนเกิด",
  dateyear: "ปีเกิด",
  sex: "เพศ",
  age: "อายุ",
  ethnicity: "เชื้อชาติ",
  nationality: "สัญชาติ",
  "register.Validation.sex.Required": "โปรดกรอกเพศ",
  "register.Validation.ethnicity.Required": "โปรดกรอกเชื้อชาติ",
  "register.Validation.nationality.Required": "โปรดระบุสัญชาติ",
  male: "ชาย",
  female: "หญิง",
  other: "อื่น ๆ",
  "blog.blog16.title": "9 ที่เที่ยวหน้าหนาว ขับรถชิล ๆ ใกล้กรุงเทพฯ นิดเดียว",
  "assurer.pleasefillouttheform": "กรุณากรอกแบบฟอร์ม",
  Mr: "นาย",
  Mrs: "นาง",
  Ms: "นางสาว",
  Master: "เด็กชาย",
  Miss: "เด็กหญิง",
  Prefix: "คำนำหน้า",
  Identification_Number: "เลขประจำตัวประชาชน",
  "register.Validation.Prefix": "โปรดกรอกคำนำหน้า",
  "register.Validation.Identification.Number": "โปรดกรอกเลขประจำตัวประชาชน",
  employee: "รถรับส่งพนักงาน",
  contactname: "ชื่อผู้ติดต่อ",
  "register.Validation.contactname": "โปรดกรอกชื่อผู้ติดต่อ",
  pickuppoint: "จุดรับ",
  "register.Validation.pickuppoint": "โปรดกรอกจุดรับ",
  deliverypoint: "จุดส่ง",
  "register.Validation.deliverypoint": "โปรดกรอกจุดส่ง",
  passenger: "จำนวนผู้โดยสาร",
  "register.Validation.passenger": "โปรดกรอกจำนวนผู้โดยสาร",
  contactMore: "ถ้ายังไม่ได้ราคาหรือรถที่ถูกใจติดต่อเราตามช่องทางด้านล่างนี้ได้เลย",
}



// WEBPACK FOOTER //
// ./src/languageProvider/locales/th_TH.ts